'use client';
import React from 'react';
import { Column, TitleMedium, BodyMedium } from '../../styles';
import { NoEntriesImage } from './styles';
import { useTranslations } from 'next-intl';
import { BoxProps } from '@mui/material';
import { useTheme } from '@emotion/react';

interface Props extends BoxProps {
    title?: string;
    text?: string;
}

const NoEntries = ({ title, text, ...boxProps }: Props) => {
    const t_filtering = useTranslations('filtering');
    const theme = useTheme();

    return (
        <Column {...boxProps} sx={{ alignItems: 'center', ...boxProps.sx }}>
            <Column sx={{ alignItems: 'center', textAlign: 'center' }} width={'50%'}>
                <NoEntriesImage />
                <TitleMedium>{title ?? t_filtering('no_entries')}</TitleMedium>
                <BodyMedium style={{ color: theme.colors.text }}>
                    {text ?? t_filtering('no_entries_description')}
                </BodyMedium>
            </Column>
        </Column>
    );
};
export { NoEntries };
